import Button from "@atomaro/ui-kit/components/Button/Button/Button";
import {ControlsWrapper} from "widgets/profile/ui/styles.ts";

type ProfileInfoControlsProps = {
  showEditor?: boolean;
  isDisabled: boolean;
  onClose: () => void;
  onOpen: () => void;
  onSubmit: () => void;
  asidePadding?: boolean;
}

export const ProfileInfoControls =
  ({isDisabled, showEditor, onClose, onOpen, onSubmit, asidePadding = true}: ProfileInfoControlsProps) => {
  
  return (
    <ControlsWrapper $asidePadding={asidePadding}>
      {
        showEditor ? (
          <>
            <Button
              label={"Сохранить"}
              type='submit'
              variant={"primary"}
              size={"m"}
              disabled={isDisabled}
              onClick={onSubmit}
            />
            <Button
              label={"Отменить"}
              variant={"ghost"}
              colorScheme="neutral"
              size={"m"}
              onClick={(event) => {
                event.stopPropagation()
                onClose()
              }}
            />
          </>
        ) : (
          <Button
            label={"Редактировать"}
            variant={"primary"}
            size={"m"}
            onClick={(event) => {
              event.stopPropagation()
              onOpen()
            }}
          />
        )
      }
    </ControlsWrapper>
  )
}